import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import VentasCommercialForm from '../../../components/Ventas/VentasCommercialForm';
import { POS_CONFIRMED_STATE } from '../../../utils/ventasPosNavigation';

const CreateVentasOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialIssueDate = location.state?.issue_date || null;

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nueva venta</h1>
          <p className="text-gray-600 mt-1">Registre una orden de venta con productos y precios</p>
        </div>
        <VentasCommercialForm
          mode="order"
          isPageMode
          initialIssueDate={initialIssueDate}
          onClose={() => navigate('/ventas/orders', { state: POS_CONFIRMED_STATE })}
          onSuccess={() =>
            navigate('/ventas/orders', {
              replace: true,
              state: { ...POS_CONFIRMED_STATE, orderSavedMessage: 'Venta registrada' },
            })
          }
        />
      </div>
    </div>
  );
};

export default CreateVentasOrder;
